import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { indexUrl: String };

  async fetchCompanyData(event) {
    const email = event.target.value.trim();
    if (!email) return;

    loader.show();

    const encodedEmail = btoa(email);

    $.ajax({
      type: "GET",
      url: `${this.indexUrlValue}?email=${encodeURIComponent(encodedEmail)}`,
      dataType: "script",
    });
  }
}
